import React from "react";
import { Outlet } from "react-router-dom";
import "./MainLayout.css";
import Sidebar from "../../layouts/sidebar/Sidebar";
import Header from "../../layouts/header/Header";

interface Props {
  setIsAuthenticated: (auth: boolean) => void;
}

const MainLayout: React.FC<Props> = ({ setIsAuthenticated }) => {
  return (
    <>
      <Header setIsAuthenticated={setIsAuthenticated} />
      <div className="main-layout">
        <Sidebar />
        <div className="main-content">
          <Outlet />
        </div>
      </div>
    </>
  );
};

export default MainLayout;
